export interface IAddressDto {
    street?: string | null
    zip?: string | null
    city?: string | null
    countryName?: string | null
}

export default class Address {
    street?: string
    zip?: string
    city?: string
    countryName?: string

    constructor(dto: IAddressDto) {
        this.street = dto.street ?? undefined
        this.zip = dto.zip ?? undefined
        this.city = dto.city ?? undefined
        this.countryName = dto.countryName ?? undefined
    }

    toDto(): IAddressDto {
        return {
            street: this.street,
            zip: this.zip,
            city: this.city,
            countryName: this.countryName,
        }
    }

    print({ notFormatted }: { notFormatted?: boolean } = {}): string {
        if (this.isEmpty()) return ""
        return (`${this.street ? `${this.street}${notFormatted ? ", " : " \n"}` : ""}` +
            `${this.zip ? `${this.zip} ` : ""}${this.city || ""}${(this.zip || this.city) && this.countryName ? ", " : ""}${this.countryName || ""}`)
            .trim()
    }

    printNarrow(): string {
        if (this.isEmpty()) return ""
        const zipAndCity = `${this.zip ? `${this.zip} ` : ""}${this.city || ""}`.trim()
        return (`${this.street ? `${this.street} \n` : ""}` +
            `${zipAndCity ? `${zipAndCity} \n` : ""}${this.countryName || ""}`)
            .trim()
    }

    printForSearch(): string {
        if (this.isEmpty()) return ""
        return [this.street, this.zip, this.city, this.countryName]
            .filter(s => !!s)
            .join(" ")
            .trim()
    }

    printZipCity(): string {
        if (!this.zip && !this.city) return ""
        return [this.zip, this.city].join(" ").trim()
    }

    printZipCityCountry(): string {
        if (!this.zip && !this.city && !this.countryName) return ""
        return [[this.zip, this.city].join(" "), this.countryName].join(", ").trim()
    }

    isEmpty(): boolean {
        return !!(
            !this.street
            && !this.zip
            && !this.city
            && !this.countryName
        )
    }

    isFull(): boolean {
        return !!(
            this.street
            && this.zip
            && this.city
            && this.countryName
        )
    }
}
